import { createAction } from 'typesafe-actions';
import { BwicPositionBase } from '../types/bwic/BwicPositionBase';
import { InventoryPosition } from '../types/inventory/InventoryPosition';

const bwicLogShow = createAction('bwic-log/SHOW',
    resolve => (security: BwicPositionBase | InventoryPosition) =>
        resolve({ security })
);
const bwicLogReset = createAction('bwic-log/RESET');
const bwicLogExportDataRequest = createAction('bwic-log/EXPORT_DATA_REQUEST',
    resolve => (securityId: number) => resolve({ securityId })
);
const bwicLogExportDataSuccess = createAction('bwic-log/EXPORT_DATA_SUCCESS');
const bwicLogExportDataFailure = createAction('bwic-log/EXPORT_DATA_FAILURE',
    resolve => (error: string) => resolve({ error })
);

export const bwicLogActions = {
    bwicLogShow,
    bwicLogReset,
    bwicLogExportDataRequest,
    bwicLogExportDataSuccess,
    bwicLogExportDataFailure
}
